import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { AuthService } from './auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { ReadConfigService } from '../common/read-config.service';
import { OutageNoticeComponent } from 'src/app/outage-notice/outage-notice.component';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private oauthService: OAuthService,
    private readConfigService: ReadConfigService) { }

  routingNotAllowed = true;
  private currentUrl = '';

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.readConfigService.getDarkFeatureFlag(this.readConfigService.getOutageDFName())) {
      const outageDetails = this.readConfigService.getOutageScheduledDetails();
      if (outageDetails && outageDetails.maintenanceFlag) {
        sessionStorage.clear();
        this.router.navigate(['/login']);
        return false;
      }
    }
    const url: string = state.url;
    if (sessionStorage.getItem('access_token') === null) {
      console.log('access token missing, redirecting to error page from authguard');
      this.router.navigate(['/forbidden'], { queryParams: { usererror: true } });
      return false;
    } else if (!this.oauthService.hasValidAccessToken()) {
      console.log('Invalid token, redirecting to error page from authguard');
      this.router.navigate(['/forbidden'], { queryParams: { usererror: true } });
      return false;
    }
    let canContinue = this.checkLogin(url);
    if (!canContinue) { return canContinue; }

    this.authService.isInEditMode$().forEach(message => { this.routingNotAllowed = message; });

    if (!this.routingNotAllowed) {
      canContinue = confirm('All unsaved changes will be lost. Do you want to continue?');
      if (canContinue) {
        this.authService.formChanged(true);
        this.routingNotAllowed = true;
      }
    }
    const splitUrls = this.authService.splitUrls(url);
    this.currentUrl = url.slice(1);
    setTimeout(() => {
      if (['login', 'callback', '', 'account', 'error', 'usererror', 'landing-page'].indexOf(this.currentUrl) < 0) {
        const finalUrl = splitUrls.length < 2 ? splitUrls[0] : splitUrls[1];
        const uploadsV2 = this.readConfigService.getDarkFeatureFlag('Uploads v2');
        if ((!uploadsV2 && !this.authService.getDarkKeyValue(finalUrl)) ||
          (uploadsV2 && splitUrls[0] !== 'uploads' && !this.authService.getDarkKeyValue(finalUrl))) {
          this.router.navigate(['/forbidden']);
          return false;
        }
      }
    }, 2000);
    return canContinue;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = `/${route.path}`;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn) {
      if (url.includes('login') || url === '/') {
        const darkFeatureValue = sessionStorage.getItem('uploadsFeature');
        if (darkFeatureValue === 'true') {
          this.router.navigate(['/account']);
        } else {
          this.router.navigate(['/home']);
        }
      }
      return true;
    }

    this.authService.loginRedirectUrl = url;
    if (!url.includes('login')) {
      this.authService.goToLogin();
      return false;
    } else {
      return true;
    }
  }
}
